var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.479,
    height: 71.123,
    viewBox: "0 0 98.479 71.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_109",
    d: "M88.141.6a5.471,5.471,0,0,1,8.19,7.222l-.454.514L35.694,68.521a5.471,5.471,0,0,1-7.222.454l-.514-.454L.6,41.165a5.471,5.471,0,0,1,7.222-8.19l.514.454L31.826,56.911Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.04639f0a335be597ba1fe9934e4ebfe3.svg";
export { ForwardRef as ReactComponent };